import React from "react";
import "./vivre.css";
import OverlayCard from "../../components/OverlayCard";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Carousel } from "../../components/VerticalCarousel";
import vivre from "../../assets/vivre/main.png";
import sia from "../../assets//solutions/sia.png";
import image1 from "../../assets/vivre/image 62.png"
import image11 from "../../assets/vivre/image 63.png"
import b1 from "../../assets/vivre/viv1.png"
import b2 from "../../assets/vivre/viv2.png"
import b3 from "../../assets/vivre/viv3.png"
import CardGrid from "../../components/productCardsGrid/productInfoCards";

export default function Vivre() {
const cards=[
  {
    "title": "AI Playlist Creation Increases Operational Efficiency",
    "description": "Boost productivity with centralized content control. Manage, edit, and distribute your media effortlessly from one streamlined dashboard for maximum efficiency."
  },
  {
    "title": "Multi-Project Management & Workflow Automation",
    "description": "Easily oversee and coordinate multiple TV real estate projects in one place. Automate curation workflows for faster delivery and consistent quality."
  },
  {
    "title": "Custom Widgets & Personalized Content Discovery",
    "description": "Enhance viewer engagement with interactive widgets and hyper-personalized content recommendations tailored to audience preferences."
  },
  {
    "title": "Monetization & Brand Amplification",
    "description": "Drive revenue growth with strategic content placement, branded partner integrations, and advanced ad management—supported by fast, reliable customer service to keep operations running smoothly."
  },
  {
    "title": "UX Personalization & Smart Scheduling",
    "description": "Deliver personalized user experiences and easily schedule content blackouts to meet programming requirements without interruptions."
  },
  {
    "title": "Faster App Delivery",
    "description": "Accelerate development with customizable layouts and gain valuable insights through analytics for data-driven decision-making."
  }
]





  const whitepapers = [
    {
      id: 1,
      src: vivre,
      alt: "image1 for carousel",
    },
    {
      id: 2,
      src: image1,
      alt: "image 2 for carousel",
    },
    {
      id: 2,
      src: image11,
      alt: "image 2 for carousel",
    },
  ];
  const blogs = [
    { title: 'Easy Control', description: 'Gain easy control of your content distribution, with all the necessary actions available in one place. ', name: '', image: b1 },
    { title: 'Flexible', description: 'Customize your content as per your own preferences at any moment with just a few clicks.', name: '', image: b2 },
    { title: 'Informative', description: 'Get live analytical data about your platform/content’s performance to plan out future decisions.', name: '', image: b3 },
  
  ];
  return (
    <div>
    <div className="vivre-main" style={{background: "black"}}>
      <div className="vivre-container">
        <div className="vivre-logo">
          <img src={require("../../assets/vivre/HospitalityLogo.png")} alt="" />
          <h3>Vivre</h3>
        </div>
        <div className="vivre-des">
          <p>
         A powerful tool that augments CMS platforms by enabling dynamic, real-time UI/UX management. It empowers operators with intuitive, efficient, and cost-effective control over frontend experiences without the need for constant developer involvement.
          </p>
        </div>
        <OverlayCard blogs={blogs} />
      </div>
      <div className="cus-carousel">
        {/* <img src={require("../../assets/vivre/SARA Insights.png")} /> */}
        <Carousel data={whitepapers} />
        <div className="sara-cus-des">
          <div className="sara-cus-title">
            <h3>Multiple Projects,</h3>
            <h3> One Account</h3>
            <p>• All your projects can be present together under one account, which allows for quick changes across multiple platforms.
            </p>
            <p>• Get information about which screens in a project are active, along with the option to quickly modify them.</p>
          </div>

        </div>
      </div>
      <div>
        <div className="w-m-s-p">
          <div className="sara-title2">
            <h3>What makes our Vivre Services Special</h3>
          </div>
        <div>
          <CardGrid cards={cards}/>
        </div>
        </div>
      </div>
   
    </div>
       <NewFooter />
    </div>
  );
}
